import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuController, NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MockProfileService } from 'src/app/services/mock/mock-profile-service';
import { MockEventService } from 'src/app/services/mock/mock-event-service';
import { StoryContextService } from 'src/app/services/mock/story-context.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: false
})
export class MainMenuComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  profile: any = null;
  isOnline: boolean = true;
  versionNumber = '1.0.0-demo';

  constructor(
    private _navCtrl: NavController,
    private menu: MenuController,
    private router: Router,
    private _profileService: MockProfileService,
    private _eventService: MockEventService,
    private storyContext: StoryContextService
  ) {
    this.subscriptions.push(
      this._eventService.networkStatusChange.subscribe((isOnline: boolean) => {
        this.isOnline = isOnline;
      })
    );
  }

  async ngOnInit(): Promise<void> {
    this._profileService.getProfile().subscribe(profile => {
      this.profile = profile;
    });
    
    // Update profile when story changes
    this.subscriptions.push(
      this.storyContext.getCurrentStoryId().subscribe(() => {
        this._profileService.getProfile().subscribe(profile => {
          this.profile = profile;
        });
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
  }

  async goToStories(): Promise<void> {
    await this.menu.close();
    // Clear story context when going back to story selection
    this.storyContext.setStory(null, 1);
    this.router.navigate(['/']);
  }

  async myProfile(): Promise<void> {
    await this.menu.close();
    await this._navCtrl.navigateForward('/home/myProfile');
  }

  async closeMenu(): Promise<void> {
    await this.menu.close();
  }
}

